import type { SystemStyleObject } from "@ecco/ui/theme-tools";
import { space } from "@ecco/ui/tokens";

export const headerStyle: SystemStyleObject = {
    fontSize: "desktopHeading4",
    textAlign: "center",
    fontWeight: "bold",
    color: "black",
};

export const headerInlineResultsStyle: SystemStyleObject = {
    fontSize: "desktopHeading4",
    fontWeight: "normal",
};

export const progressBarStyle: SystemStyleObject = {
    height: space["0.2"],
    background: "gray.50",
    "> div": {
        backgroundColor: "black",
    },
};
